import React, { useState } from "react";
import editRegionMinQtyAPI from "../api/editRegionMinQtyAPI";
import editRegionNameAPI from "../api/editRegionNameAPI";
import deleteRegionAPI from "../api/deleteRegionAPI";

const RegionComponent = ({ region, setAlert, setAlertData, setRegionDeletable }) => {
  // variable
  const [regionName, setRegionName] = useState(region.name);
  const [minQty, setMinQty] = useState(region.minQty);

  // edit region handler
  const editRegionHandler = async () => {
    if (regionName !== region.name) {
      const res_change_name = await editRegionNameAPI(region.id, regionName);
      if (res_change_name === 200) {
        setAlertData({
          title: "تم تغيير إسم المنطقة بنجاح",
          content: `تم تغيير إسم المنطقة من ${region.name} الي ${regionName}`,
        });
      } else {
        setAlertData({
          title: "حدث خطا ما ",
          content: `حدث خطا ما في تغيير إسم المنطقة ${regionName}`,
        });
      }
    }
    if (minQty !== region.minQty) {
      const res_status = await editRegionMinQtyAPI(region.id, minQty);
      if (res_status === 200) {
        if (minQty === 0) {
          setAlertData({
            title: "وقف إتاحة الطلبات",
            content: `ثم وقف إتاتحة الطلبات لمنطقة ${regionName}`,
          });
        } else {
          setAlertData({
            title: `تحديث الطلبات للمنطقة ${regionName}`,
            content: `ثم تحديث الحد الإدني من الطلبات لهذه المنطقة ليصبح ${minQty}`,
          });
        }
      } else {
        setAlertData({
          title: `حدث خطا ما`,
          content: `فشل عملية تعديل الحد الأدني من الطلبات للمنطقة ${region.name}`,
        });
      }
    }

    // Show Alert
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 5000);
  };

  const deleteRegion = async (e) => {
    e.preventDefault();
    const res_status = await deleteRegionAPI(region.id);
    if (res_status === 200) {
      setAlertData({
        title: `تم حذف المنطقة ${region.name} بنجاح`,
      });
    } else {
      setAlertData({
        title: `حدث خطا ما`,
        content: `فشل في عملية حذف المنطقة ${region.name}`,
      });
    }
    // alerting
    setAlert(true);
    setRegionDeletable(true);
    setTimeout(() => {
      setAlert(false);
    }, 5000);
  };

  return (
    <>
      <tr className="border-b border-gray-200 hover:bg-gray-100">
        <td className="px-4 py-4 text-right ">
          <button
            className="text-blue-600 font-semibold text-md mx-2"
            onClick={(e) => {
              e.preventDefault();
              setMinQty(0);
              editRegionHandler();
            }}
          >
            وقف إتاحة الطلبات لهذه المنطقة
          </button>
          /
          <button
            className="text-blue-600 font-semibold text-md mx-2"
            onClick={() => editRegionHandler()}
          >
            تعديل
          </button>{" "}
          /
          <button
            className="text-red-600 font-semibold text-md mx-2"
            onClick={(e) => deleteRegion(e)}
          >
            حذف
          </button>
        </td>
        <td className="px-4 py-4 text-right font-bold text-lg">
          <input
            type="number"
            className="py-2 px-4 border rounded"
            value={minQty}
            dir="rtl"
            onChange={(e) => setMinQty(e.target.value)}
          />
        </td>
        <td className="px-4 py-4 text-right font-bold text-lg">
          <input
            type="text"
            className="py-2 px-4 border rounded"
            value={regionName}
            onChange={(e) => {
              setRegionName(e.target.value);
            }}
            dir="rtl"
          />
        </td>
      </tr>
    </>
  );
};

export default RegionComponent;
